import React, { useState, useCallback } from 'react';
import CategoryNameComponent from '../CategoryNameComponent';
import TransactionSummaryComponent from '../TransactionSummaryComponent';
import MoneyComponent from "../../elements/MoneyComponent";

export default function SummaryCategoryItem(props) {
	const { selectedDates, amountDisplayed, category, totalToShowPercentageOf, categoryMouseEnter, categoryMouseLeave } = props;
	const [expanded, updateExpanded] = useState(false);

	const toggleExpand = useCallback(() => {
		updateExpanded(!expanded);
	}, [expanded]);

	const mouseEnter = useCallback(() => {
		if(!categoryMouseEnter) {
			return;
		}
		categoryMouseEnter(category);
	}, [categoryMouseEnter]);
	const mouseLeave = useCallback(() => {
		if(!categoryMouseLeave) {
			return;
		}
		categoryMouseLeave(category);
	}, [categoryMouseLeave]);

	const budget = category.getMultiBudget(selectedDates);
	let transactions = null;
	if(expanded) {
		transactions = budget.getTransactions();
	}


	// console.log('rawr', budget.getBudgeted());

	const totalToDisplay = amountDisplayed(budget);

	const isEmpty = totalToDisplay === 0;
	// console.log('what is', totalToDisplay, totalToShowPercentageOf);
	return (
		<div
			onClick={toggleExpand}
			onMouseEnter={mouseEnter}
			onMouseLeave={mouseLeave}
			className={`collection-item ${expanded ? 'expanded' : ''} `}>
			<div className='main clickable'>
				{(!isEmpty && !!totalToShowPercentageOf) &&
				<span className='percentage'>{(Math.round(totalToDisplay / totalToShowPercentageOf * 100))}%</span>
				}
				<CategoryNameComponent
					className='title'
					category={category}
					content={category.fullName()}
				/>{' '}
				{!isEmpty && <MoneyComponent amount={totalToDisplay} />}
			</div>
			{expanded &&
			<div className='collection-transaction'>
				{transactions.map((transaction) => (
					<TransactionSummaryComponent
						key={transaction.id}
						transaction={transaction}
						viewOnly={true}
						showCategory={false}
						showSplitCategories={true}
						categoryEditable={false}
					/>
				))}
			</div>
			}
		</div>
	);
}